export enum ShareState {
  selectSubgroup = 'selectSubgroup',
  selectManager = 'selectManager',
}
